const LoadingState = ({ currentLang }) => {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto mb-4"></div>
        <p className="text-gray-600">
          {currentLang === "ar" ? "جاري التحميل..." :
           currentLang === "fr" ? "Chargement..." : "Loading..."}
        </p>
      </div>
    </div>
  );
};

export default LoadingState;